import { render, staticRenderFns } from "./ServiceShopifyOnlineServices.vue?vue&type=template&id=56a07e1b&scoped=true&"
import script from "./ServiceShopifyOnlineServices.vue?vue&type=script&lang=js&"
export * from "./ServiceShopifyOnlineServices.vue?vue&type=script&lang=js&"
import style0 from "./ServiceShopifyOnlineServices.vue?vue&type=style&index=0&id=56a07e1b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a07e1b",
  null
  
)

export default component.exports